import { render, staticRenderFns } from "./ApplicationTierce.vue?vue&type=template&id=066bcc2f&"
import script from "./ApplicationTierce.vue?vue&type=script&lang=js&"
export * from "./ApplicationTierce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports